import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import Exception from './Exception';
var RuntimeException = /*#__PURE__*/function (_Exception) {
  _inherits(RuntimeException, _Exception);
  function RuntimeException(message) {
    var _this;
    _classCallCheck(this, RuntimeException);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RuntimeException).call(this, message));
    _this.name = Object.keys({
      RuntimeException: RuntimeException
    })[0];
    return _this;
  }
  return RuntimeException;
}(Exception);
export { RuntimeException as default };